import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { Icon } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next';

import './Navbar.scss';
import NavbarLang from 'components/NavbarLang'
import { loginRequest, redirectUri } from 'auth/entra';
//Actions imports
import {setUserAuth} from 'actions/rootActions';


function NavbarAuth(props){
  const { userAuth } = props;
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const account = instance.getActiveAccount() || (accounts.length > 0 ? accounts[0] : null);
  const loading = inProgress !== InteractionStatus.None;
  const user = useMemo(() => account ? {
      email: account.username,
      name: account.name,
      sub: account.localAccountId,
    } : null,
    [account]
  );
  const { t } = useTranslation();

  useEffect(() => {
    userAuth(user);
  }, [userAuth, user]);

  return(
      <div className="korhonenNav__auth">
        <NavbarLang/>
        {!isAuthenticated && !loading &&(
          <button type="button" className="korhonenNav__authButton" onClick={() => instance.loginRedirect(loginRequest)}>
            <Icon name='lock open'/><span>{t("navbar.signIn")}</span>
          </button>
        )}
        {isAuthenticated && user && !loading &&(
          <button type="button" className="korhonenNav__authButton" onClick={() => instance.logoutRedirect({ account, postLogoutRedirectUri: redirectUri })} title={t("navbar.signOut")}>
            <Icon name='user circle'/><span>{user.email}</span>
          </button>
        )}
      </div>
    );
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  userAuth : (user) => dispatch(setUserAuth(user))
})

export default connect(
  mapStateToProps,mapDispatchToProps
)(NavbarAuth);
